import React from 'react';

import { StyledButton } from './styled';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  theme?: string;
  size?: string;
  type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<ButtonProps> = props => {
  const { children, theme, size, type, ...rest } = props;

  return (
    <StyledButton type={type} theme={theme} size={size} {...rest}>
      {children}
    </StyledButton>
  );
};

Button.defaultProps = {
  theme: 'primary',
  type: 'button',
  size: 'medium',
};

export { Button };
